module.exports = "https://web-assets.ifttt.com/packs/media/card_brands/visa-570a8829.svg";